module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.5c7c6912.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Bold.woff
 ** module id = 1334
 ** module chunks = 0
 **/